import { useState } from 'react'
import Garage from 'components/Form/AdvancedCalculator/PresenceGarage/PresenceGarage'
import GaragePosition from 'components/Form/AdvancedCalculator/GaragePosition/GaragePosition'
import GarageSize from 'components/Form/AdvancedCalculator/GarageSize/GarageSize'
import HouseFace from 'components/Form/AdvancedCalculator/HouseFace/HouseFace'
import CalculationResult from 'components/Form/AdvancedCalculator/CalculationResult/CalculationResult'
import { useAppSelector } from 'redux/hooks'
import { makeSelectGarage } from 'redux/features/bienAVendre/selectors'

const CALCULATOR_STEP = {
  PresenceGarage: 'presencegarage',
  GaragePosition: 'garageposition',
  GarageSize: 'garagesize',
  HouseFace: 'houseface',
  CalculationResult: 'calculationresult',
}

interface Props {
  onValidate: () => void
  onReset: () => void
}

const AdvancedCalculator = ({
  onValidate,
  onReset,
}: Props): JSX.Element | null => {
  const garage = useAppSelector(makeSelectGarage)

  const [step, setStep] = useState(CALCULATOR_STEP.PresenceGarage)
  if (step === CALCULATOR_STEP.PresenceGarage) {
    if (garage === 1) {
      return (
        <Garage
          onContinueButtonClick={() => setStep(CALCULATOR_STEP.GaragePosition)}
        />
      )
    }
    return (
      <Garage
        onContinueButtonClick={() => setStep(CALCULATOR_STEP.HouseFace)}
      />
    )
  }
  if (step === CALCULATOR_STEP.GaragePosition) {
    return (
      <GaragePosition
        onContinueButtonClick={() => setStep(CALCULATOR_STEP.GarageSize)}
        onBackButtonClick={() => setStep(CALCULATOR_STEP.PresenceGarage)}
      />
    )
  }
  if (step === CALCULATOR_STEP.GarageSize) {
    return (
      <GarageSize
        onContinueButtonClick={() => setStep(CALCULATOR_STEP.HouseFace)}
        onBackButtonClick={() => setStep(CALCULATOR_STEP.GaragePosition)}
      />
    )
  }
  if (step === CALCULATOR_STEP.HouseFace) {
    if (garage === 1) {
      return (
        <HouseFace
          onContinueButtonClick={() =>
            setStep(CALCULATOR_STEP.CalculationResult)
          }
          onBackButtonClick={() => setStep(CALCULATOR_STEP.GarageSize)}
        />
      )
    }
    return (
      <HouseFace
        onContinueButtonClick={() => setStep(CALCULATOR_STEP.CalculationResult)}
        onBackButtonClick={() => setStep(CALCULATOR_STEP.PresenceGarage)}
      />
    )
  }
  if (step === CALCULATOR_STEP.CalculationResult) {
    return (
      <CalculationResult
        onValidateButtonClick={onValidate}
        onResetButtonClick={() => {
          setStep(CALCULATOR_STEP.PresenceGarage)
          onReset()
        }}
      />
    )
  }
  return null
}

export default AdvancedCalculator
